var mobileOpen = false;

export default function() {
    
    var toggler = document.getElementById("menu-toggler");
    var body = document.getElementById("body");
    var header = document.getElementById("header");
    var menu = document.getElementById("main-menu");

    toggler.addEventListener("click", function(e) {
        e.preventDefault();

        mobileOpen = !mobileOpen;

        if (mobileOpen) {
            body.classList.add("mobile-menu--active");
            header.classList.add("mobile-menu--active");
            toggler.classList.add("open");
            menu.classList.add("open");
        } else {
            body.classList.remove("mobile-menu--active");
            header.classList.remove("mobile-menu--active");
            toggler.classList.remove("open");
            menu.classList.remove("open");
        }
    });

    // Subnav
    var subnav_triggers = document.querySelectorAll('.has-submenu');
    for ( var i = 0; i < subnav_triggers.length; i++ ) {
        var el = subnav_triggers[i];
        el.addEventListener("click", function(e) {
            e.preventDefault();
            var el = e.target;
            el.parentNode.classList.toggle("open");
        });
    }
    
    // Scroll back menu
    var didScroll;
    var lastScrollTop = 0;
    var delta = 10;
    var navbarHeight = header.offsetHeight;

    window.addEventListener("scroll", function(event){
        didScroll = true;
    });

    setInterval(function() {
        if (didScroll) {
            
            var st = window.scrollY || window.pageYOffset;

            if(Math.abs(lastScrollTop - st) <= delta)
                return;
            
            if ( st > lastScrollTop && st > navbarHeight ){
                header.classList.add("hidden");
                var active_submenus = document.querySelector(".header__nav__item.open");
                if(active_submenus !==null){
                    active_submenus.classList.remove("open");
                }
            } else {
                if( st + window.innerHeight < document.body.clientHeight ) {
                    header.classList.remove("hidden");
                }
            }

            if( st > 100 ){
                header.classList.add("tiny-nav");
            } else {
                header.classList.remove("tiny-nav");
            }
            lastScrollTop = st;

            didScroll = false;
        }
    }, 100);
    //   

}